import React from 'react';
import KomunikatI from '../../assets/GISwNauce_Komunikat_I_2026.pdf';

import './main.css';

const Main = () => {
  return (
    <div className="giswnauce__main">
      <span className="anchor-main" id="giswnauce_main"></span>
      <div className="giswnauce__main-content">
        <div className="content-description">
          <h1>XII Edycja Ogólnopolskiej Konferencji GIS w&nbsp;nauce</h1>
          <h2>Szanowni Państwo!</h2>

          <p>
            Serdecznie zapraszamy do udziału w&nbsp;XII edycji Ogólnopolskiej Konferencji <b>GIS w Nauce</b>, która odbędzie się w dniach <b>24-25 września 2026 roku</b> 
            &nbsp;na <b>Uniwersytecie Warmińsko-Mazurskim w Olsztynie</b>. Konferencja organizowana jest przez <b>Instytut Gospodarki Przestrzennej i Geografii</b>. 
            <b>Wydarzenie zostało objęte</b> honorowym patronatem <b>JM Rektora Uniwersytetu Warmińsko-Mazurskiego w Olsztynie, dr. hab. Jerzego A. Przyborowskiego, prof. UWM,</b> 
            &nbsp;patronatem technologicznym <b>ESRI Polska</b> i patronatem medialnym <b>Radia UWM FM</b>. Wydarzenie jest współorganizowane przez <b>Polską Akademię Nauk</b>.
          </p>

          <p>
            Konferencja <i>GIS w Nauce</i> od lat stanowi istotne forum integrujące środowisko naukowe zajmujące się systemami informacji geograficznej, geoinformacją oraz geoinformatyką. Wydarzenie skupia przedstawicieli różnych dyscyplin naukowych, umożliwiając wymianę idei, doświadczeń oraz wyników badań związanych z zastosowaniem technologii GIS w naukach ścisłych, przyrodniczych, technicznych i humanistycznych.
          </p>

          <p>
            Głównym celem konferencji jest prezentacja najnowszych osiągnięć naukowych w obszarze systemów informacji geograficznej oraz stworzenie przestrzeni do merytorycznej dyskusji nad szerokim spektrum ich zastosowań badawczych i praktycznych. Wydarzenie stanowi również doskonałą okazję do spotkania przedstawicieli środowiska naukowego, wymiany poglądów oraz nawiązania nowych form współpracy.
          </p>

          <p>
            Tegoroczna edycja, kontynuując wieloletnią tradycję konferencji, po raz drugi odbędzie się w Olsztynie – mieście akademickim o silnych tradycjach naukowych i dynamicznie rozwijającym się zapleczu badawczym. Program konferencji obejmuje <b>sesje tematyczne, sesje posterowe oraz panel dyskusyjny</b>, które umożliwią pogłębienie wiedzy i rozwój kompetencji w zakresie GIS. 
          </p>

          <p>Pierwsza konferencja <i>GIS w Nauce</i>, zainicjowana w <b>2012</b> roku przez prof. Iwonę Jażdżewską oraz prof. Jacka Urbańskiego, odbyła się na Uniwersytecie Łódzkim. Od tego czasu wydarzenie cieszy się nieustannie rosnącym zainteresowaniem środowiska naukowego. Do udziału zapraszamy zarówno doświadczonych badaczy, jak i młodych naukowców rozpoczynających swoją działalność naukową.</p>
          
          <p>Organizator konferencji zapewnia uczestnikom bogaty pakiet konferencyjny obejmujący:</p>

          <p>
            <ul>
              <li>materiały konferencyjne oraz publikację abstraktów na stronie konferencji</li>
              <li>dwa obiady serwowane podczas konferencji z możliwością wyboru menu,</li>
              <li>uroczystą kolację konferencyjną z regionalnymi przekąskami i elementami kuchni Warmii i Mazur,</li>
              <li>ciągły serwis kawowy, obejmujący kawę, herbatę, owoce oraz przekąski,</li>
              <li>sesje tematyczne, sesja z posterami oraz sesja specjalna w formule debaty,</li>
              <li>stoiska partnerów konferencji,</li>
              <li>atrakcyjny rabat na nocleg w miejscu konferencji ze śniadaniem i darmowym parkingiem z możliwością rezerwacji do dwóch dób hotelowych w preferencyjnej cenie.</li>
              <li>konkursy oraz niespodzianki z nagrodami dla uczestników.</li>
            </ul>
          </p>

          <p>Konferencja „GIS w Nauce” to nie tylko przestrzeń wymiany wiedzy i doświadczeń naukowych, ale również okazja do integracji środowiska GIS w wyjątkowej atmosferze regionu Warmii i Mazur.</p>

          <p>Uprzejmie informujemy, że:</p>

          <p>
            <ul>
              <li><b>do 14 sierpnia 2026 r.</b> prowadzona jest rejestracja uczestników zgłaszających <b>referaty (wystąpienia)</b>,</li>
              <li><b>do 21 sierpnia 2026 r.</b> możliwa będzie wyłącznie rejestracja uczestników zgłaszających postery naukowe lub uczestniczących <b>bez czynnego udziału</b>.</li>
            </ul>
          </p>

          <p>Mamy nadzieję, że spotkamy się licznie w <b>Olsztynie, stolicy województwa warmińsko-mazurskiego</b>, aby wspólnie kontynuować tradycję konferencji „GIS w Nauce” i przyczynić się do dalszego rozwoju badań nad systemami informacji geograficznej.</p>

          <a href={ KomunikatI } target="_blank" rel="noreferrer"><h3>
          KOMUNIKAT I
          </h3></a>
        </div>
      </div>
    </div>
  )
}

export default Main